<template>
    <v-select
    prepend-inner-icon="mdi-web"
    class="lang-select"
    v-model="lang"
    :items="langs"
    color="primary-1"
    @change="setLang"
    solo></v-select>
</template>

<script>
import {i18n, loadLanguageAsync} from "@/locale";
import { mapActions, mapGetters } from 'vuex';
import store from "../store";

export default {
  name: 'MultiLangSelector',
  data() {
    return {
      lang: this.$store.getters.locale,
      langs: [
        { text: '中文', value: 'tw'},
        { text: 'English', value: 'en'},
        { text: '日本語', value: 'jp'},
        { text: '한국어', value: 'kr'},
      ],
    }
  },
  methods: {
    ...mapActions({
      setLocale: 'setLocale'
    }),
    setLang() {
      this.setLocale(this.lang);
      loadLanguageAsync(this.lang);
    }
  }
}
</script>

<style lang="scss">
// ::v-deep {
  .v-input.lang-select {
    align-content: center;
    align-items: center;
    width: 115px;
    max-width: 115px;

    .v-input__control {
      display: flex;

      .v-text-field__details {
        display: none;
      }

      .v-input__slot {
        padding: 0 !important;
        margin: 0 !important;
        box-shadow: none !important;
        background: none;

        .v-input__prepend-inner .v-input__icon > i {
          color: $primary-dark;
        }

        .v-input__append-inner .v-input__icon.v-input__icon--append i {
          color: $primary-dark;
        }
        .v-select__selections {
          width: 64px;
          flex-direction: row-reverse;
          .v-select__selection--comma {
            color: $primary-dark;
            width: 100%;
            text-align: center;
            margin: 0 !important;
          }
        }
      }
    }
  }
// }
</style>